export default {
  map_unavailable: 'Karttaa ei voitu ladata. Lataa sivu uudelleen kokeillaksesi uudestaan.',
  stubs: {
    name: 'Toimitusalue {{number}}',
  },
  buttons: {
    add_new_zone: 'Lisää uusi alue',
  },
  toasts: {
    failed_to_load_data: 'Toimitusalueiden lataaminen epäonnistui',
  },
};
